import { Component, inject, OnDestroy, OnInit, VERSION } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';
import { AppService } from '../services/app.service';

@Component({
    selector: 'lib-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    imports: [TranslocoModule]
})
export class FooterComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  appService = inject(AppService);

  appVersion: string;
  angularVersion: string;
  copyright: string;

  constructor() {
    this.appVersion = 'v1.0.0';
    this.angularVersion = VERSION.full;
    this.copyright = `${new Date().getFullYear().toString()} © `;
  }

  ngOnInit(): void {
    this.appService
      .getAppVersion()
      .pipe(takeUntil(this.destroy$))
      .subscribe(version => {
        this.appVersion = version;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
